import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí. Acceso y descarga inmediata en cuanto completás el pago.'
  }, {
    q: '¿Funciona si nunca hice detailing?',
    a: 'Sí. El MegaPack arranca desde cero absoluto con el Tomo 1. Si nunca tocaste un auto de forma profesional es exactamente por donde tenés que empezar.'
  }, {
    q: '¿Necesito equipo caro para arrancar?',
    a: 'No. El Bono 4 te dice exactamente qué comprar primero con menos de $15.000.'
  }, {
    q: '¿El MegaPack funciona si vivo en el interior o en otro país de LATAM?',
    a: 'Sí. El método funciona igual en todo el país y en toda la región. Disponible en Argentina, Uruguay, Chile, Colombia, México y más.'
  }, {
    q: '¿En cuánto tiempo puedo hacer mi primer servicio pago?',
    a: 'Con el Tomo 1 y el Bono 4 en mano podés cobrar tu primer servicio en menos de una semana.'
  }, {
    q: '¿Y si el MegaPack no es para mí?',
    a: 'Garantía de 30 días sin preguntas. Te devolvemos el 100% de tu inversión.'
  }];
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-10 uppercase" data-id="element-92">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-93">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-94" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-95">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-96">
        <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-97">{question}</span>
        <ChevronDown className={`w-6 h-6 text-gray-500 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-98" />
      </button>
      {isOpen && <div className="px-6 pb-4 text-gray-700 font-medium text-lg" data-id="element-99">
          {answer}
        </div>}
    </div>;
}